<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab class="mt-3" :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button :disabled="!this.userLogin.is_super"
                            :loading="loading"
                            label="Save"
                            @click="save"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form>
                            <gofix-card classContent="mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            class="mb-0"
                                            label="Company"
                                            vLabel="name"
                                            :options=[]
                                            :filterable="false"
                                            v-model="user.organization"
                                            :clearable="false"
                                            :disabled="true"
                                            required>
                                            <template #gofixInput:dropdown:no-options>
                                                Please enter to search organization!
                                            </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-checkbox :disabled="true" class="ml-16 mt-30"><span class="ml-2">Disabled</span></b-form-checkbox>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field class="ml-16 mt-30" label="MS OTP Authentication" oneline>
                                            <b-form-checkbox :value="true" v-model="user.microsoft2fa_enable" :unchecked-value="false" switch>
                                            </b-form-checkbox>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-form-input label="User Name" v-model="user.name" autocomplete="off" required></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input required label="Department" v-model="user.department" autocomplete="off"></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Designation" v-model="user.designation" autocomplete="off"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="Role"
                                            vLabel="name"
                                            :filterable="true"
                                            :multiple="true"
                                            :required="true"
                                            v-model="roleDefault"
                                            :disabled="true"
                                            :options=roleOptions>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Email" type="email" v-model="user.email" autocomplete="off" required :disabled="!$route.path.includes('add')"></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input
                                            :value="user.email_verified_at | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY HH:mm')"
                                            desc="dd.mm.yyyy hh:mm"
                                            label="Email verified at"
                                            disabled>
                                        </gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input :disabled="!this.userLogin.is_super" label="Password" v-model="user.password">
                                            <template #gofixInput:text:after-desc>
                                                <p class="desc color-error">
                                                    <span v-if="validate && user.password && user.password.length >= 8 && user.repassword !== user.password">Password doesn't match</span>
                                                    <span v-if="validate && user.password && user.password.length < 8">Minimum 8 characters</span>
                                                </p>
                                            </template>
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input :disabled="!this.userLogin.is_super" label="Confirm Password" v-model="user.repassword">
                                            <template #gofixInput:text:after-desc>
                                                <p class="desc color-error">
                                                    <span v-if="validate && user.repassword && user.repassword.length >= 8 && user.repassword !== user.password">Password doesn't match</span>
                                                    <span v-if="validate && user.repassword && user.repassword.length < 8">Minimum 8 characters</span>
                                                </p>
                                            </template>
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="Preferred Mode of Contact"
                                            :clearable="false"
                                            vLabel="reference_value_text"
                                            :reduce="option => option.reference_value_text"
                                            :filterable="false"
                                            :required="true"
                                            v-model="user.preferred_contact_mode"
                                            :disable-capitalize-label="true"
                                            :options="preferred_mode">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4" class="custom-cases gofixLogoContract gofixSignature">
                                        <gofix-text-field label="Signature" class="editPhotoValue" classLabel="font-14" classValue="pl-0" classInner="d-block" oneline>
                                            <div class="d-flex align-items-center viewer mt-11">
                                                <template v-if="user.signature_image">
                                                    
                                                </template>
                                                <div class="upload-btn-wrapper m-0">
                                                    <b-form-file :disabled="true" v-model="attachmentFile" accept=".jpg, .png, .gif" plain></b-form-file>
                                                    <gofix-button :disabled="true" :label="!user.signature_image || !user.signature_image.length ? 'ADD PHOTO' : 'CHANGE PHOTO'" outline></gofix-button>
                                                </div>
                                            </div>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Login Count" oneline>{{ user.login_count ? user.login_count : 0 }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Last Login At" oneline>{{ user.last_login ? user.last_login : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Created At" oneline>{{ user.created_at ? user.created_at : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Created By" oneline>{{ user.created_by_name ? user.created_by_name : '---' }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Last Updated At" oneline>{{ user.updated_at ? user.updated_at: null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Updated By" oneline>{{ user.updated_by_name ? user.updated_by_name : '---' }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col md="12">
                                      <gofix-button label="See last 10 logins" @click="modals.last_login.open = true"></gofix-button>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <div>
                                <h3 class="gofixContentTitle">Address</h3>
                            </div>
                            <template v-for="(address,index) in user.address">
                                <gofix-card classContent="mb-0 position-relative" :key="index">
                                    <template slot="gofixCard:before_card_content">
                                        <button class="icon-button gofixIconButton gofixPositionTopRight position-absolute" @click="removeUserAddress(index)">
                                            <svg width="18" height="20" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 5H19" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M17 5V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5H17Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8 10V16" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12 10V16" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </button>
                                    </template>
                                    <div class="pr-4">
                                        <b-row class="mt-4">
                                            <b-col md="4">
                                                <gofix-form-dropdown
                                                    label="Salutation"
                                                    vLabel="reference_value_text"
                                                    :filterable="false"
                                                    :required="user.mailing_address_id_tmp === index"
                                                    v-model="address.salutation"
                                                    :reduce="option => option.reference_value_text"
                                                    :options="salutations">
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="First Name"
                                                    autocomplete="off"
                                                    v-model="address.first_name"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="Last Name"
                                                    autocomplete="off"
                                                    v-model="address.last_name"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-text-field label="Address">
                                                    <template slot="gofixTextField:after_label">
                                                        <gofix-button class="editRight float-right" label="Edit" noBorder fontNormal small @click="openAddressModal(address,index)"></gofix-button>
                                                    </template>
                                                    {{address.display_address}}
                                                </gofix-text-field>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input-number
                                                    label="Mobile Phone"
                                                    v-model="address.primary_phone"
                                                    :integer-limit="15"
                                                    :include-thousands-separator="false"
                                                    :allowDecimal="false">
                                                </gofix-form-input-number>
                                            </b-col>
                                            <b-col md="4">
                                                <b-form-checkbox class="ml-16 mt-30" v-model="address.phone_verified"><span class="ml-2">Mobile Phone Verified</span></b-form-checkbox>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input-number
                                                    label="Second Phone"
                                                    v-model="address.secondary_phone"
                                                    :integer-limit="15"
                                                    :include-thousands-separator="false"
                                                    :allowDecimal="false">
                                                </gofix-form-input-number>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="Email Address"
                                                    v-model="address.email"
                                                    type="email" autocomplete="off"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <div class="d-flex justify-content-between">
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="address.email_verified"><span class="ml-2">Email Verified</span></b-form-checkbox>
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="user.mailing_address_id_tmp" :value="index"><span class="ml-2">Default Mailing</span></b-form-checkbox>
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="user.billing_address_id_tmp" :value="index"><span class="ml-2">Default Billing</span></b-form-checkbox>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </gofix-card>
                            </template>
                            <div class="action">
                                <gofix-button label="Add Address" :disabled="!this.userLogin.is_super" @click="addUserAddress" outline></gofix-button>
                            </div>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Address" title="Address" hide-footer :centered="true" ref="modal-address">
            <b-form class="pb-10">
                <gofix-form-input label="Street Number" v-model="activeAddress.street_no"></gofix-form-input>
                <gofix-form-input label="Street Name" v-model="activeAddress.street_name"></gofix-form-input>
                <gofix-form-input label="Unit no" v-model="activeAddress.unit_no"></gofix-form-input>
                <gofix-form-input label="Building Name" v-model="activeAddress.building_name"></gofix-form-input>
                <gofix-form-input label="Country" v-model="activeAddress.country" disabled></gofix-form-input>
                <gofix-form-input label="Postal code" v-model="activeAddress.postal_code"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="hanldeAddress" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create-Check-User" :title="modals.last_login.title" hide-footer :centered="true" v-model="modals.last_login.open" ref="modal-check">
        <div class="pl-10 pr-10">
            <ul class="list-unstyled list-client" v-if="login_histories" v-bind:class="{'run-loading':modals.last_login.loading}">
                <template v-for="(item, index) in login_histories">
                <li v-bind:key="item.id">
                        <p>
                        IP: {{ item.ip }}
                        <small>Login at: {{ item.login_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss")}}</small>
                        <small>Logout at: {{ item.logout_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss")}}</small>
                        <small>Bowse engine: {{ item.browse_engine}}</small>
                        </p>
                    </li>
                </template>
            </ul>
        </div>
      </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { generalAddressFormat } from "./../../_commonVar.js";
    export default {
        name: 'suppper-user-info',
        data () {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                ],
                user: {
                    id: null,
                    name: '',
                    organization: null,
                    email: '',
                    password: '',
                    repassword : '',
                    address: [],
                    phone: '',
                    street_no : '',
                    street_name : '',
                    building_name : '',
                    unit_no : '',
                    country : 'Singapore',
                    postal_code : '',
                    active: false,
                    role: [],
                    preferred_contact_mode: "Email",
                },
                modals: {
                    last_login: {
                        open: false,
                        loading: false,
                        title: 'Latest login',
                    }
                },
                loading: false,
                validate: false,
                preferred_mode: [],
                attachmentFile: null,
                roleDefault: 'Super Admin',
                roleOptions: ['Super Admin'],
                login_histories: [],
                salutations: [],
                activeAddress: {},
            }
        },
        created () {
            if(this.userLogin && this.userLogin.id){
                this.$store.dispatch('v2UserController/getUserSuper', [])
                .then(response => {
                    this.user = response.data.data;
                    this.setData(response.data.data);
                })
                .catch(error => {});
            }
            this.getSalutations();
            this.getPreferredMode();
        },
        watch:{
            userLogin : function(val){
                if(val && val.id) {
                    this.$store.dispatch('v2UserController/getUserSuper', [])
                    .then(response => {
                        this.user = response.data.data;
                        this.setData(response.data.data);
                        this.loadLoginHistories();
                    })
                    .catch(error => { });
                }
            }
        },
        computed: {
            ...mapGetters({
                userLogin: "AuthController/user",
            })
        },
        methods:{
            setData(data) {
                if(data != null) {
                    this.user.id = data.id
                    this.user.name = data.name,
                        this.user.email = data.email,
                        this.user.organisation_id = data.organisation_id,
                        this.user.organization = data.organization
                    this.user.role = data.role
                    this.user.active = data.active
                    if(data.address && data.address.length > 0) {
                        this.user.phone = data.address[0].phone
                        this.user.address_id = data.address[0].id,
                            this.user.street_no = data.address[0].street_no,
                            this.user.street_name = data.address[0].street_name,
                            this.user.building_name = data.address[0].building_name,
                            this.user.unit_no = data.address[0].unit_no,
                            this.user.country = data.address[0].country,
                            this.user.postal_code = data.address[0].postal_code
                    }
                    // this.user.password = ''
                    // this.user.repassword = ''
                    if(data.id == '' || data.id == null) {
                        this.user.password = data.password
                        this.user.repassword = data.repassword
                    }
                    return;
                }
                // this.user.password = ''
                // this.user.repassword = ''
            },
            getSalutations(){
                let filter = {reference_type: "Salutation"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.salutations = response.items;
                    })
            },
            getPreferredMode(){
                let filter = {reference_type: "Preferred Mode of Contact"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.preferred_mode = response.items;
                    })
            },
            hanldeAddress() {
                this.activeAddress.display_address = generalAddressFormat(this.activeAddress)
                this.$refs['modal-address'].hide()
            },
            save() {
                if(this.loading) return false;
                this.validate = true;
                this.loading = true;

                if(!this.user.email){
                    this.$alertNotification("Email is required", "danger");
                    return;
                }
                if(this.user.password){
                    if(this.user.password !== this.user.repassword){
                        this.$alertNotification("Re-Password doesn't match", "danger");
                        this.loading = false
                        return;
                    }
                    if(this.user.password < 8){
                        this.$alertNotification("The password > 8 characters", "danger");
                        this.loading = false
                        return;
                    } 
                }

                this.$store.dispatch(`v2UserController/updateUser`, this.user)
                    .then(async response => {
                        this.loading = false
                        await this.$alertNotification(this.$notificationV2('editing', 'user'));
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                        if(error.error.message.password) {
                            return this.$alertNotification(error.error.message.password[0], "danger");
                        }
                        if(error.error.message.email) {
                            return this.$alertNotification(error.error.message.email[0], "danger");
                        }

                        this.$alertNotification(error.error.message.error, "danger");
                    })
            },
            async loadLoginHistories(){
                let tableRequest = {
                    limit: 10,
                    page: 1,
                    isCMS: 1,
                    sortColumn: "created_at",
                    sortDirection: "DESC",
                    filter: {
                        user_id: {
                            type: "number",
                            value: this.user.id,
                            function: "=",
                            with: []
                        }
                    }
                }
                this.modals.last_login.loading = true;
                await this.$store.dispatch("AuditTrailController/getUserActivityLogs", tableRequest)
                .then(response => {
                    this.login_histories = response.items;
                    this.tableConfig.total = response.total;
                    this.modals.last_login.loading = false;
                })
                .catch(err => {
                    this.modals.last_login.loading = false;
                })
            },
            addUserAddress(){
                this.user.address.push({
                    building_name: '',
                    city: null,
                    contact_name: null,
                    country: "Singapore",
                    display_address: "",
                    display_name: "",
                    email: null,
                    email_verified: false,
                    first_name: null,
                    full_address: "",
                    geo_location: null,
                    id: null,
                    last_name: null,
                    phone_verified: false,
                    postal_code: "",
                    primary_phone: "",
                    salutation: null,
                    secondary_phone: null,
                    street_name: "",
                    street_no: "",
                    unit_no: ""
                });
            },
            removeUserAddress(index){
                this.user.address.splice(index, 1);
                if(this.user.mailing_address_id_tmp && index <= this.user.mailing_address_id_tmp){
                    if(index < this.user.mailing_address_id_tmp){
                        this.user.mailing_address_id_tmp = this.user.mailing_address_id_tmp - 1;
                    }else{
                        this.user.mailing_address_id_tmp = null;
                    }

                }
                if(this.user.billing_address_id_tmp && index <= this.user.billing_address_id_tmp){
                    if(index < this.user.billing_address_id_tmp){
                        this.user.billing_address_id_tmp = this.user.billing_address_id_tmp - 1;
                    }else{
                        this.user.billing_address_id_tmp = null;
                    }
                }
            },
            openAddressModal(address,index){
                this.activeAddress = address;
                this.activeAddress.key = index;
                this.$refs['modal-address'].show()
            },
        },
    }
</script>
